import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { loadingBarMiddleware } from 'react-redux-loading-bar';
import history from './history';
import rootReducer from './rootReducer';
const router = routerMiddleware(history);

const middlewares = [thunk, router];

let devToolsExtension = f => f;

if (process.env.NODE_ENV === 'development') {
  const { createLogger } = require('redux-logger');

  const logger = createLogger({ collapsed: true });
  middlewares.push(logger);

  if (window.devToolsExtension) {
    devToolsExtension = window.devToolsExtension();
  }
}

export default function configureStore(initialState) {
  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(
        ...middlewares,
        loadingBarMiddleware({
          promiseTypeSuffixes: ['BEGIN', 'SUCCESS', 'FAILURE'],
        }),
      ),
      devToolsExtension,
    ),
  );

  if (module.hot) {
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}



// WEBPACK FOOTER //
// ./src/common/configStore.js